"use client"

import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"
import { cn } from "../lib/utils.ts"
import { Toggle as TogglePrimitive } from "radix-ui"

/* shadcn/ui Toggle, restyled: pressed is the active surface, never an accent fill. */
const toggleVariants = cva(
  "inline-flex items-center justify-center gap-1.5 whitespace-nowrap rounded-control text-ui font-medium text-fg-subtle transition-colors duration-(--duration-fast) ease-standard hover:bg-fg/6 hover:text-fg disabled:pointer-events-none disabled:text-fg-faint data-[state=on]:bg-fg/10 data-[state=on]:text-fg [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4",
  {
    variants: {
      variant: {
        default: "bg-transparent",
        outline: "border border-border bg-transparent hover:border-border-strong",
      },
      size: {
        default: "h-control min-w-(--control-height) px-2",
        sm: "h-control-sm min-w-(--control-height-sm) px-1.5",
        lg: "h-control-lg min-w-(--control-height-lg) px-2.5",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
)

function Toggle({
  className,
  variant,
  size,
  ...props
}: React.ComponentProps<typeof TogglePrimitive.Root> &
  VariantProps<typeof toggleVariants>) {
  return (
    <TogglePrimitive.Root
      data-slot="toggle"
      className={cn(toggleVariants({ variant, size, className }))}
      {...props}
    />
  )
}

export { Toggle, toggleVariants }
